import styled from '@emotion/styled'
import {
  fadeIn,
  MediaQueries,
  slideInUp,
  theme,
} from '@hhgtech/hhg-components/misc'

export const StyledPremiumContentBanner = styled.div`
  &[data-portal='false'] {
    /* position: absolute; */
    width: 100%;
    padding: 32px 24px;
    position: relative;
  }
  &[data-portal='true'] {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${Number(theme.zIndexes.zIndex100) - 1};
    transform: translate3d(0, 100%, 0);
    animation: ${slideInUp} 500ms linear 2s forwards;
    padding-bottom: 32px;
  }
  background: ${theme?.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  min-height: 150px;
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    height: 100px;
    left: 0;
    background-image: linear-gradient(180deg, #fff0, #fff);
    width: 100%;
    opacity: 0;
    animation: ${fadeIn} 500ms ease-in-out 2s forwards;
  }
  .btn {
    span {
      width: max-content;
    }
  }
  .close-btn {
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
    background: #ffffff;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${MediaQueries.mbDown} {
    /* bottom: 44px; */
    &[data-portal='false'] {
      width: auto;
    }

    &[data-portal='true'] {
      bottom: 56px;
      border-bottom: 2px solid ${theme?.colors.primaryBase};
    }

    &::before {
      height: 60px;
    }

    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 16px;
    gap: 12px;
    .btn {
      align-self: center;
    }
  }
`
